<template>
	<div id="create">
    <v-speed-dial :bottom="true" :right="true" direction="left" :open-on-hover="true" transition="slide-y-reverse-transition">
      <template v-slot:activator>
        <v-btn v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab">mdi-close</v-icon>
          <v-icon v-else>mdi-plus</v-icon>
        </v-btn>
      </template>
      <div class="text-center">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn dark small fab color="red" v-on="on" @click="back">
              <v-icon>mdi-arrow-left-bold</v-icon>
            </v-btn> 
          </template>
          <span style="position: relative;">{{ $t('button_back') }}</span>
        </v-tooltip>
      </div>
      <div class="text-center">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
              <v-btn dark small fab color="indigo" v-on="on">
                <v-icon>mdi-arrow-up-bold</v-icon>
              </v-btn> 
          </template>
          <span style="position: relative;">{{ $t('button_top') }}</span>
        </v-tooltip>
      </div>
      <div class="text-center">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn dark small fab color="green" v-on="on">
              <router-link to="/" style="color: white;">
                <v-icon>mdi-home</v-icon>
              </router-link>
            </v-btn>
          </template>
          <span style="position: relative;">{{ $t('button_home') }}</span>
        </v-tooltip>
      </div>
    </v-speed-dial>
  </div>
</template>

<script>
  export default {
    data: () => ({
      fab: false
    }),
    methods: {
      back(){
        this.$router.go(-1)
      }
    }
  }
</script>


<style scoped>
  /* This is for documentation purposes and will not be needed in your application */
  #create .v-speed-dial {
    position: fixed;
  }

  #create .v-btn--floating {
    position: relative;
  }
</style>